import React from 'react'
import { FormattedMessage } from 'react-intl'
import { modalManager } from '../modals/ModalWrapper'
import modalsMessages from '../modals/messages'

export const formatMessage = error => <FormattedMessage {...error} />

export const showErrorModal = errors =>
	modalManager.showModal(<FormattedMessage {...modalsMessages.error} />, [].concat(errors))
